import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SignInPageController } from 'pages/SignIn/machine';

export function Title(): JSX.Element {
  const [t] = useTranslation();
  const state = SignInPageController.useSelector((s) => s);

  if (state.matches('usePasskeys')) {
    if (state.matches('usePasskeys.done')) {
      return <h2>{t('forms.create_passkey_success_title')}</h2>;
    }
    if (state.matches('usePasskeys.failed')) {
      return <h2>{t('forms.create_passkey_failure_title')}</h2>;
    }
    return <h2>{t('forms.create_passkey_title')}</h2>;
  }

  return <h2>{t('forms.sign_in')}</h2>;
}
